import React, { useContext } from 'react';
import { APIContext } from '../contexts/APIContext';
import { trackUserClicks, getValidToken } from '../utils';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { Tooltip, TooltipProvider, TooltipTrigger } from './ui/Tooltip';
import { TooltipContent } from '@radix-ui/react-tooltip';

export const ViewMore = (props: any) => {
  const { title, description, img, link } = props;
  const {
    userDetails,
    chatSessionId,
    websocketConnectionRef: { current: websocket },
    WBUId,
    AppName,
    accounts,
  } = useContext(APIContext);

  return (
    <>
      <div
        className="cardSection mb-[40px]"
        onClick={() => {
          (async () => {
            const token = await getValidToken();
            trackUserClicks(
              websocket,
              'Increase your Knowledge',
              userDetails,
              chatSessionId,
              WBUId,
              AppName,
              accounts,
              token
            );
          })();
        }}
      >
        <div className=" mb-5  h-[114px] flex items-center gap-5 cursor-pointer hover:bg-[#544D63] ">
          <img className="block h-[114px] " src={img} alt="Woman's Face" />
          <div>
            <div className="text-left align-middle hover:bg-[#544D63]">
              <a href={link} target="_blank" rel="noreferrer" className="flex flex-col gap-3">
                <p className="text-[#D9D9D9] font-semibold text-base">{title}</p>
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger>
                      <p className="text-left text-[#D9D9D9] text-sm font-normal add-ellipsis-line-one">
                        {description}
                      </p>
                    </TooltipTrigger>
                    <TooltipContent
                      side="top"
                      className="bg-white border-0 max-w-[240px] drop-shadow-[0_12px_16px_rgba(0,0,0,0.12)] p-2 rounded-md"
                      sideOffset={2}
                    >
                      <p className="tooltip-content text-black bg-white text-xs not-italic">{description}</p>
                      <TooltipPrimitive.Arrow width={11} height={5} style={{ fill: 'white' }} />
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
